<div class="gt-page-header">
  <h1><i class="fa fa-hand-paper-o"></i> Down For Maintenance</h1>
</div>
<div class="gt-page-body-dark">
  <div class="holder-404">
    <img src="assets/img/hand.png" alt="Access Denied">
    <h3>Sorry. This Module is .</h3>
    <p>Please email: <a [href]="'mailto:' + email" target="_top">{{ email }}</a> to request access to the page.</p>
  </div>
</div>
